import { MenuItem } from "@blueprintjs/core"
import { isString, startCase } from "lodash-es"
import React from "react"
// import { log } from "util";
import useFetchIcons from "hooks/useFetchIcons"
import StaticSelector from "../Atoms/StaticSelector"

function getName(url) {
  try {
    return startCase(url.substring(31, url.length - 4))
  } catch (err) {
    return ""
  }
}
export default function IconSelector({ ...props }) {
  const { data, loading } = useFetchIcons(
    "https://cdn.vesatogo.com/crop_meta.json"
  )
  const list = data && data.length > 0 ? data : []

  return (
    <StaticSelector
      big={true}
      loading={loading}
      items={list}
      renderText={item => (
        <>
          {isString(item) ? (
            <img
              className="mr-2"
              src={item}
              width={20}
              height={20}
              alt={item && item.name}
            />
          ) : (
            <img
              className="mr-2"
              src={item && item.url && item.url.svg}
              width={20}
              height={20}
              alt={item && item.name}
            />
          )}

          {isString(item)
            ? getName(item)
            : item && item.name
            ? startCase(item.name)
            : "Select Icon"}
        </>
      )}
      itemRenderer={(item, { handleClick, modifiers }) => {
        return (
          <MenuItem
            key={`${item && item.name} - ${item && item.url && item.url.svg}`}
            icon={
              <img
                width={25}
                height={25}
                alt={item && item.name}
                src={item && item.url && item.url.svg}
              />
            }
            active={modifiers.active}
            onClick={handleClick}
            text={item && startCase(item.name)}
            labelElement={null}
          />
        )
      }}
      {...props}
    />
  )
}
